import { useLanguage } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-white/10 py-10 px-6 bg-[#070d14] text-white/50 text-xs font-mono-code" data-testid="main-footer">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
        <div>
          <span className="text-white">{t.footer.company}</span>
          <span className="block mt-1">{t.footer.address}</span>
          <a href="mailto:info@trustmastercrm.it" className="hover:text-[#E2C079] transition-colors" data-testid="footer-email-link">
            info@trustmastercrm.it
          </a>
        </div>
        <div className="text-[11px] text-center md:text-right">
          <div className="mb-2 flex justify-center md:justify-end gap-4">
            <a href="/privacy" className="hover:text-[#E2C079] transition-colors" data-testid="footer-privacy-link">{t.legal.privacy}</a>
            <a href="/cookie-policy" className="hover:text-[#E2C079] transition-colors" data-testid="footer-cookies-link">{t.legal.cookies}</a>
          </div>
          <div data-testid="footer-compliance">{t.footer.compliance}</div>
        </div>
      </div>
    </footer>
  );
}
